
<v-dialog
    v-model    = "value"
    :max-width = "500"
    persistent
>
    <v-card>
        <v-card-title v-html="$t('inc.attach.overwrite.query')"></v-card-title>
        <v-card-text  v-html="$t('inc.attach.overwrite.text')"></v-card-text>

        <v-card-actions>
            <v-btn
                @click = "onCancel"
                color  = "primary"
                text
            >
                {{ $t('common.cancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                @click = "onAttach"
                color  = "primary"
                text
            >
                {{ $t('common.no') }}
            </v-btn>
            <v-btn
                @click = "onAttachOverwrite"
                color  = "primary"
                text
            >
                {{ $t('common.yes') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
